import React from "react";
import { Outlet } from "react-router-dom";

import { Processes } from "@src/components/MainApp/Alerts/Processes";
import { AdminSideNav } from "@src/components/Navigation/AdminSideNav/AdminSideNav";
import { IgPageContent } from "@src/utils/IgPageContent";

import { AlertBanner } from "./alerts/AlertBanner";
import { AppLayoutShell } from "./layout/AppLayoutShell";

export const AdminPageProvider = () => {
  return (
    <AppLayoutShell
      banner={<AlertBanner />}
      sideNav={<AdminSideNav />}
      maxWidth={1600}
    >
      <IgPageContent>
        <Processes />
        <Outlet />
      </IgPageContent>
    </AppLayoutShell>
  );
};
